/** Stable id shared with VaulDrawer titleId so Select Category dialog announces its visible heading (Power select_B15). */
export const SELECT_CATEGORY_HEADING_ID = 'select-category-heading'
